export default __webpack_public_path__ + "static/media/model_ready.6380d8c2.png";